class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach(tempEl => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
          this.setVideoState(tempEl, false)
        }
      })
    }

    const contentEl = itemEl.querySelector(this.els?.content?.selector)
    const currentState = itemEl.getAttribute('aria-expanded') === 'true'

    itemEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    itemEl.setAttribute('aria-expanded', !currentState)

    this.setVideoState(itemEl, !currentState)
  }

  setVideoState (itemEl, isOpen) {
    const videoEl = itemEl.querySelector('[data-accordion-group-el="video"]')

    if (!videoEl) return

    if (isOpen) {
      if (!videoEl.dataset.loaded) {
        videoEl.querySelectorAll('source[data-src]').forEach(sourceEl => {
          sourceEl.src = sourceEl.dataset.src
        })
        videoEl.dataset.loaded = 'true'
        videoEl.load()
      }

      videoEl.play().catch(() => {})
    } else {
      videoEl.pause()
      videoEl.currentTime = 0
    }
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
